import { Stack, Typography } from '@mui/material';
import { CreateButton } from 'react-admin';
import useAppBarHeight from '@/components/misc/useAppBarHeight';

export const LeadEmpty = () => {
    const appbarHeight = useAppBarHeight();
    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            gap={3}
            sx={{ height: `calc(100dvh - ${appbarHeight}px)` }}
        >
            <img src="./img/empty.svg" alt="No leads found" />
            <Stack gap={0} alignItems="center">
                <Typography variant="h6" fontWeight="bold">
                    No leads found
                </Typography>
                <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                    gutterBottom
                >
                    It seems your Lead list is empty.
                </Typography>
            </Stack>
            <CreateButton variant="contained" label="New lead" />
        </Stack>
    );
};
